export default __webpack_public_path__ + "static/media/ComingSoon-AppStore.07822531.png";